import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import { reduxForm, Field } from "redux-form";
import { connect } from "react-redux";
import { loginSuperAdminUser } from "../../actions/authAction";
import { closeModal, openModal } from "../../actions/modalAction";
import { Button, Form, Image } from "semantic-ui-react";
import CheckboxInput_2 from "../form/CheckboxInput_2";
import TextInput from "../form/TextInput";
//import SelectInput from "../form/SelectInput";
import { combineValidators, isRequired } from "revalidate";

const validate = combineValidators({
  //************user */

  userId: isRequired("UserId"),
  password: isRequired("Password"),
});

class LoginForSuperAdmin extends Component {
  state = {
    showP: false,
  };

  // componentDidMount(){

  // }

  onSubmit = (values) => {
    this.props.loginSuperAdminUser(values, this.props.history);
  };

  handleRegisterModal = () => {
    this.props.openModal("RegisterModal");
  };
  toggle = () => this.setState({ showP: !this.state.showP });
  render() {
    const { handleSubmit } = this.props;
    const showPass = this.state.showP ? "text" : "password";

    return (
      <div
        className="font-family-Roboto"
        style={{ borderWidth: "5px", marginTop: "50px" }}
      >
        <div
          className="card-attached border"
          style={{ maxWidth: "500px", margin: "auto" }}
        >
          {/*  */}

          <div className="disflex-paginator">
            <Image
              className=" border-logo "
              size="small"
              src="/logo.png"
              style={{ marginRight: ".5em" }}
            />
          </div>

          {/*  */}
          <div className="masthead  font-18B textAlign-center pxy-10 color-white">
            Login to your account(SuperAdmin)
          </div>
          <br />
          {/*  */}
          <div className=" ">
            <div className=" label pxy-10">
              <Form onSubmit={handleSubmit(this.onSubmit)}>
                <label>User Id</label>{" "}
                <span style={{ color: "red" }}>
                  <b>*</b>
                </span>
                <Field
                  name="userId"
                  type="text"
                  component={TextInput}
                  placeholder="User Id"
                />
                <label>Password</label>{" "}
                <span style={{ color: "red" }}>
                  <b>*</b>
                </span>
                <Field
                  name="password"
                  type={showPass}
                  //type="password"
                  component={TextInput}
                  placeholder="Password"
                />
                <CheckboxInput_2
                  label="Show Password"
                  onChange={this.toggle}
                  checked={this.state.showP}
                />
                <br />
                <br />
                <div className="flex-center">
                  <Button
                    color="teal"
                    //type="button"
                  >
                    Login
                  </Button>
                  <Button color="blue" type="button">
                    <Link className="link-gr" to="/">
                      Cancel
                    </Link>
                  </Button>
                </div>
              </Form>
            </div>
            <br />
            {/* <div className="format-login2 flex-direction-column border-db-top ">
              <div>
                {" "}
                <span> New to us?</span>{" "}
                <span
                className='btnG'
                    onClick={this.handleRegisterModal}
                  >
                    Register
                  
                </span>
              </div>
              <div>
                Forgot Your Password?{" "}
                <Button
                  //floated="right"
                  color="blue"
                  type="button"
                  as={Link}
                  to={`/formpassreset`}
                  onClick={() => this.props.closeModal()}
                >
                  Reset
                </Button>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  state,
});

export default connect(mapStateToProps, {
  loginSuperAdminUser,
  closeModal,
  openModal,
})(
  reduxForm({
    form: "LoginForSuperAdmin", // a unique identifier for this form
    //destroyOnUnmount: false,
    validate,
  })(withRouter(LoginForSuperAdmin))
);
